import React, { FC, useState } from 'react'
import useOutsideClick from '../../hooks/useOutsideClick'
import { Icon, Text } from './InfoComponent.style'

interface Props {
    text: string
}

const InfoComponent: FC<Props> = ({ text }) => {
    const [showText, setShowText] = useState(false)
    const ref = useOutsideClick(() => setShowText(false))

    return (
        <div ref={ref}>
            <Icon
                onClick={() => setShowText(!showText)}
                onMouseEnter={() => setShowText(true)}
                onMouseLeave={() => setShowText(false)}
            ></Icon>
            {showText && <Text>{text}</Text>}
        </div>
    )
}

export default InfoComponent
